module.exports = __webpack_public_path__ + "static/media/pw.005061a1.svg";